var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M10.178 7.339a2.839 2.839 0 1 1-5.678 0 2.839 2.839 0 0 1 5.678 0M9.83 10.89a4.339 4.339 0 1 1 1.06-1.06l2.114 2.113-1.061 1.06z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }